//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MpMenuGroup from "./MpMenuGroup";

export default {
  name: 'mp-navigation-drawer',
  components: {
    MpMenuGroup
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    logo: {
      type: Object,
      default: () => ({})
    },
    serviceMenu: {
      type: Object,
      default: () => ({})
    },
    show: {
      type: Boolean,
      default: null
    },
    width: {
      type: [Number, String],
      default: 190,
    }
  },
  computed: {
    drawer: {
      get() {
        return this.show;
      },
      set(drawer) {
        this.$emit('change', drawer);
      }
    }
  }
}
